import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { assignOrderItem, createOrderItem } from "@/model/OrderItem.model";
import { inject, onMounted, reactive, ref, watch } from "vue";
import { OrderItemServiceSymbol, OrderServiceSymbol, ProductServiceSymbol } from "@/InjectionSymbols";
import ProductMetaContainer from "@/components/ProductMetaContainer.vue";
import { CartItemDto } from "@/dto/CartItemDto";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditOrderItemPanel',
    props: {
        orderId: { type: Number, required: true },
        orderItem: { type: Object, required: true },
        product: { type: Object, required: false }
    },
    emits: ['orderItemUpdate', 'cancel'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const orderService = inject(OrderServiceSymbol);
        const orderItemService = inject(OrderItemServiceSymbol);
        const productService = inject(ProductServiceSymbol);
        let resourceReservations = ref({});
        const editOrderItem = reactive(createOrderItem());
        const currentProduct = ref(null);
        const loadingProduct = ref(true);
        onMounted(() => {
            init();
        });
        watch(() => props.orderItem, () => {
            init();
        }, { deep: true });
        function init() {
            assignOrderItem(editOrderItem, props.orderItem);
            // Load the current product data
            if (props.orderItem.productId) {
                loadingProduct.value = true;
                productService.loadProduct(props.orderItem.productId.toString())
                    .then(product => {
                    currentProduct.value = product;
                    loadingProduct.value = false;
                })
                    .catch(() => {
                    loadingProduct.value = false;
                });
            }
            if (props.product && props.product.id) {
                orderService?.loadReservationsForOrderItem(editOrderItem.id, onReservationsLoaded);
            }
        }
        function onReservationsLoaded(reservations) {
            reservations.forEach(reservation => {
                resourceReservations.value[Number(reservation.resourceDto.id)] = reservation.reservedQuantity;
            });
        }
        /**
         * Handles the rebooking process:
         * 1. Delete the existing order item
         * 2. Create a new order item with the current product conditions
         */
        function rebookOrderItem(cartItem) {
            const cartItemDto = new CartItemDto(cartItem);
            orderItemService.updateOrderItem(props.orderId, cartItemDto, editOrderItem.id)
                .then((response) => {
                // Emit the update event with the updated order
                emit('orderItemUpdate', response.data);
            });
        }
        function cancel() {
            emit('cancel');
        }
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                persistent: "",
                "max-width": "800px"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "pa-4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-h5" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Buchung für " + _toDisplayString(__props.orderItem.productTitle), 1)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_alert, {
                                        type: "info",
                                        variant: "tonal",
                                        class: "mb-4"
                                    }, {
                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode(" Hinweis: Das Bearbeiten einer gebuchten Leistung führt zur Stornierung und Neubuchung der Leistung zu den aktuellen Konditionen. ")
                                        ])),
                                        _: 1
                                    }),
                                    (loadingProduct.value)
                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                            key: 0,
                                            class: "d-flex justify-center"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_progress_circular, { indeterminate: "" })
                                            ]),
                                            _: 1
                                        }))
                                        : (currentProduct.value)
                                            ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(ProductMetaContainer, {
                                                        product: currentProduct.value,
                                                        orderItem: __props.orderItem,
                                                        onButtonClick: rebookOrderItem
                                                    }, {
                                                        button: _withCtx(() => _cache[1] || (_cache[1] = [
                                                            _createTextVNode("Buchung aktualisieren")
                                                        ])),
                                                        _: 1
                                                    }, 8, ["product", "orderItem"])
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_actions, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, { onClick: cancel }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("Abbrechen")
                                        ])),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
